import { ContactShadows } from '@react-three/drei';

const CanvasLights = () => {
  return (
    <>
      <directionalLight
        position={[-20, 13.6, 70]}
        color={0xfff1e0}
        castShadow={true}
        intensity={0.9}
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-near={1}
        shadow-camera-far={100}
        shadow-camera-left={-20}
        shadow-camera-right={20}
        shadow-camera-top={20}
        shadow-camera-bottom={-20}
      />

      {/* <directionalLight
        position={[2.3, 1.8, 18.5]}
        color={0xe0f7ff}
        intensity={0.5}
      /> */}

      <hemisphereLight args={[0xeeeeff, 0x444444, 0.2]} />
      {/* <ambientLight color={0xffffff} intensity={0.05} /> */}

      {/* <ContactShadows
        position={[0, -1.4, 0]}
        opacity={0.4}
        width={10}
        height={10}
        blur={1.5}
        far={4}
      /> */}
    </>
  );
};

export default CanvasLights;
